import * as yup from "yup";

export const CandidateDetailsSchema = yup.object().shape({
  Fname: yup.string().required("Required"),
  //   Lname: yup.string().required("Required"),
  email: yup.string().required("Required"),
  Schedulelink: yup.string(),
  phoneNo: yup
    .string()
    .required("Required")
    .matches(/^\d{10}$/, "Phone number must be exactly 10 digits"),
  jobType: yup.string(),
  Etype: yup.string(),
  uploadcv: yup.string().required("Required"),
  departments: yup.string(),
  skills: yup.string(),
  recruterRemark: yup.string(),
  IsQulified: yup.boolean(),
  genratedBy: yup.string(),
  assignedInterviewer: yup.string(),
  interviewScheduleDate: yup.string().required("Required"),
  interviewType: yup.string().required("Required"),
  position: yup.string().required("Required"),
});
